// BowlingStats.js
import React, { useState, useEffect, useCallback } from 'react';

const BowlingStats = ({
    competitionId,
    statsFeed,
    onError
}) => {
    const [loading, setLoading] = useState(false);
    const [allStats, setAllStats] = useState({});

    const [selectedStat, setSelectedStat] = useState('mostwickets');

    const [isInitialized, setIsInitialized] = useState(false);
    const feedURL = process.env.REACT_APP_FEED_URL;
    const statEndpoints = {
        'Most Wickets': 'mostwickets',
        'Best Averages': 'bestaverages',
        'Best Economy': 'besteconomyrates',
        'Best Economy (Innings)': 'besteconomyratesinnings',
        'Best Strike-Rates': 'beststrikeratestournament',
        'Best Strike-Rates (Innings)': 'beststrikeratesinnings',
        'Most Runs Conceded (Innings)': 'mostrunsconceededinnings',
        'Most Dot Balls Bowled': 'mostdotballsbowledtournament',
        'Most Dot Balls Bowled (Innings)': 'mostdotballsbowledinnings',
        'Most Maiden Overs Bowled': 'mostmaidenoversbowledtournament'
    };

    const columnConfigs = {
        mostwickets: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'wickets', label: 'WKTS' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'average', label: 'AVG' },
                { key: 'economy', label: 'ECON' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        bestaverages: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'average', label: 'AVG' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'wickets', label: 'WKTS' },
                { key: 'economy', label: 'ECON' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        besteconomyrates: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'economy', label: 'ECON' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'wickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        besteconomyratesinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'economy', label: 'ECON' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'inningsRuns', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'inningsWickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        beststrikeratestournament: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'strikerate', label: 'SR' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'wickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'economy', label: 'ECON' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        beststrikeratesinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'strikerate', label: 'SR' },
                { key: 'overs', label: 'O' },
                { key: 'inningsRuns', label: 'R' },
                { key: 'inningsWickets', label: 'W' },
                { key: 'maidens', label: 'MD' },
                { key: 'against', label: 'AGAINST' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' }
            ]
        },
        mostrunsconceededinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'inningsRuns', label: 'R' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'maidens', label: 'MDNS' },
                { key: 'bbi', label: 'BBI' },
                { key: 'inningsWickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        mostdotballsbowledtournament: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'dots', label: 'DOTS' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'inningsWickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        },
        mostdotballsbowledinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'dots', label: 'DOTS' },
                { key: 'overs', label: 'O' },
                { key: 'inningsRuns', label: 'R' },
                { key: 'inningsWickets', label: 'W' },
                { key: 'maidens', label: 'MD' },
                { key: 'against', label: 'AGAINST' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' }
            ]
        },
        mostmaidenoversbowledtournament: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'maidens', label: 'MD' },
                { key: 'innings', label: 'I' },
                { key: 'overs', label: 'O' },
                { key: 'runs', label: 'R' },
                { key: 'bbi', label: 'BBI' },
                { key: 'matchWickets', label: 'WKTS' },
                { key: 'average', label: 'AVG' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fourwickets', label: '4W' },
                { key: 'fivewickets', label: '5W' }
            ]
        }
    };

    const fetchBowlingStats = async (endpoint) => {
        if (!competitionId) return null;

        try {
            const timestamp = new Date().getTime();
            const defaultFeed = `${feedURL}`;
            const url = `${statsFeed || defaultFeed}/stats/${competitionId}-${endpoint}.js?callback=on${endpoint}&_=${timestamp}`;

            const response = await fetch(url);
            if (!response.ok) {
                console.error(`HTTP error for ${endpoint}! status: ${response.status}`);
                return null;
            }
            
            let text = await response.text();
            
            // Remove the callback wrapper
            text = text.replace(new RegExp(`^on${endpoint}\\(|\\);?$`, 'g'), '');
            
            try {
                const data = JSON.parse(text);
                
                // Find the correct data array
                let playerData = [];
                if (Array.isArray(data)) {
                    playerData = data;
                } else if (typeof data === 'object') {
                    const arrayKeys = Object.keys(data).filter(key => Array.isArray(data[key]));
                    if (arrayKeys.length > 0) {
                        playerData = data[arrayKeys[0]];
                    }
                }

                if (!playerData.length) {
                    console.warn(`No player data found for ${endpoint}`);
                    return [];
                }

                return playerData.map(player => ({
                    player: player.BowlerName || '',
                    team: player.TeamName || '',
                    matches: player.Matches || '0',
                    wickets: player.Wickets || '0',
                    inningsWickets: player.InningsWickets || '0',
                    matchWickets: player.MatchWickets || '0',
                    innings: player.Innings || '0',
                    overs: player.OversBowled || '0',
                    runs: player.TotalRunsConceded || '0',
                    inningsRuns: player.InningsRuns || '0',
                    bbi: player.BBIW || '-',
                    average: player.BowlingAverage || '0',
                    economy: player.EconomyRate || '0',
                    strikerate: player.StrikeRate || '0',
                    fourwickets: player.FourWickets || '0',
                    fivewickets: player.FiveWickets || '0',
                    dots: player.DotBallsBowled || '0',
                    maidens: player.Maidens || '0',
                    against: player.AgainstTeamName || '',
                    venue: player.VenueName || '',
                    date: player.MatchDate ? formatDate(player.MatchDate) : '',
                }));

            } catch (parseError) {
                console.error(`Error parsing JSON for ${endpoint}:`, parseError);
                return null;
            }
        } catch (err) {
            console.error(`Error fetching ${endpoint}:`, err);
            return null;
        }
    };

    const fetchAllStatsConcurrently = useCallback(async () => {
        if (!competitionId || isInitialized) return;

        setLoading(true);
        const endpoints = Object.values(statEndpoints);
        
        try {
            const fetchPromises = endpoints.map(endpoint => 
                fetchBowlingStats(endpoint)
                    .then(data => ({ endpoint, data }))
                    .catch(() => ({ endpoint, data: [] }))
            );

            const results = await Promise.allSettled(fetchPromises);
            
            const newStats = results.reduce((acc, result) => {
                if (result.status === 'fulfilled' && result.value.data) {
                    acc[result.value.endpoint] = result.value.data;
                } else {
                    acc[result.value.endpoint] = [];
                }
                return acc;
            }, {});

            setAllStats(newStats);
            setIsInitialized(true);
        } catch (error) {
            console.error('Error fetching stats:', error);
            onError?.('Failed to load stats');
        } finally {
            setLoading(false);
        }
    }, [competitionId, statsFeed, isInitialized]);

    const handleStatChange = (event) => {
        event.preventDefault();
        const dropdownValue = event.target.value;
        const endpoint = statEndpoints[dropdownValue];
        
        requestAnimationFrame(() => {
            setSelectedStat(endpoint);
        });
    };

    useEffect(() => {
        fetchAllStatsConcurrently();
    }, [fetchAllStatsConcurrently]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString.split('T')[0]);
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                       'July', 'August', 'September', 'October', 'November', 'December'];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    if (loading && !isInitialized) {
        return <div>Loading stats...</div>;
    }

    const currentStats = allStats[selectedStat] || [];

    return (
        <div id="mcTourBowlingStats" className="tabTourContent current">
            <div className="otherStats">
                <select
                    className="mcSelectDefault otherStatsFilter"
                    onChange={handleStatChange}
                    value={Object.keys(statEndpoints).find(key => 
                        statEndpoints[key] === selectedStat
                    )}
                >
                    {Object.keys(statEndpoints).map(option => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            <div className="nicescroll_content tmtBatStatsContent js-statsTableWrap" tabIndex="5">
                <table className="mcTableDefault batCardTable" cellSpacing="0" cellPadding="0" border="0">
                    {currentStats.length > 0 ? (
                        <>
                            <thead>
                                <tr>
                                    {(columnConfigs[selectedStat] || columnConfigs.mostwickets).headers.map(header => (
                                        <th key={header.key}>{header.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentStats.map((stat, index) => (
                                    <tr key={index}>
                                        {(columnConfigs[selectedStat] || columnConfigs.mostwickets).headers.map(header => (
                                            <td key={header.key}>
                                                {header.key === 'pos' ? index + 1 : stat[header.key]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="15" style={{ textAlign: 'center', padding: '20px' }}>
                                    No data found
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
};

export default BowlingStats;